
import Vue from "vue";
import Component from "vue-class-component";
// import { Prop } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
@Component({
  components: {},
})
export default class MenuFooter extends Vue {
  mounted() {
    this.showButton();
  }
  userDetail = UserModule.userDetail;
  displayButton = "create";
  showButton() {
    if (['Operator','Operator Project','Operator Maintenance','Operator Utilities','Supervisor'].includes(this.userDetail.accessgroup["name"])) {
      this.displayButton = "read";
    } else {
      this.displayButton = "create";
    }
  }
}
